import { useEffect, useState } from "react";
import apiService from '../../services/apiService';
import '../../styles/pages/dataSets.scss';
import SamplesCard from "../../components/SamplesCard";
import DatasetsModal from "../../components/DatasetsModal";
import Add from "../../assets/icons/add"

export default function SampleCarousel() {
    const [dataSetList, setdataSetList] = useState([]);
    const [sampleList, setSampleList] = useState([]);
    const [modal, setModal] = useState(false);
    const [error, setError] = useState("")

    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    }
    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

    useEffect(() => {
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + "wfapi/sample?userId=" + userid, {
            headers: {
                'Authorization': 'Bearer ' + getDataUserToken
            }
        })
            .then(res => res.json())
            .then(data => setSampleList(data));
    }, [userid]);

    return (
        <div className="datasets-main">
            <div className="d-flex justify-content-between">
                <div style={{ fontWeight: "500", fontSize: "16px" }}> Sample Management</div>
                <div>
                    <input type="text" className="search" name="search" placeholder="Search" style={{ padding: "5px" }} />
                </div>
            </div>
            <br />
            <div style={{ fontWeight: "500", fontSize: "14px" }}>Samples</div>
            <div className="datasets-cont" >
                {sampleList?.length > 0 ?
                    <SamplesCard content={sampleList} /> :
                    error ? <div className="loading">No Private Datasets found</div> :
                        <div className="loading">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                }
            </div>
            <br />
        </div>
    );
}